// @flow

import React from 'react';
import type { TranslateType } from 'types/translateType.flow';
import { convertToNumber } from 'client/utils/format';
import InputGroup from './inputGroup';

type Props = {
  changeHandler: Function,
  label: TranslateType,
  onChange: Function,
  value: string | number,
};

const InputWeight = (props: Props) => {
  const { onChange, changeHandler, ...remainingProps } = props;
  const onWeightChange = (e: SyntheticInputEvent<>) => {
    const {
      target: { value },
    } = e;
    const weight = convertToNumber(value);

    if (value.length === 0 || (weight > 0 && weight < 1000)) {
      onChange(value);
      changeHandler(value);
    }
  };

  return (
    // changeHandler needs to be pulled off or react complains about DOM element property
    <React.Fragment>
      <InputGroup {...remainingProps} id="weight-input" onChange={onWeightChange} type="text" />
    </React.Fragment>
  );
};

InputWeight.defaultProps = {
  changeHandler: () => {},
  label: { path: 'common.label.weight' },
  onChange: () => {},
  value: '',
};

export default InputWeight;
